module.exports = __webpack_public_path__ + "img/Search.e2e16bb2.png";